export default __webpack_public_path__ + "static/cruiselogo_rcl-5692077f238396f549a217bfa0f0ea3e.png";